import { AlertListRow, GetAlertsListViewResponse } from '@fullstory/proto/fs/services/dx-objects';

export const MetricAlertsRequestTypes = {
  ArchiveAlertConfigRequest: 'MetricAlerts.ArchiveAlertConfig.Request',
  ArchiveAlertConfigSuccess: 'MetricAlerts.ArchiveAlertConfig.Success',
  ArchiveAlertConfigFailure: 'MetricAlerts.ArchiveAlertConfig.Failure',
  CreateAlertConfigRequest: 'MetricAlerts.CreateAlertConfig.Request',
  CreateAlertConfigSuccess: 'MetricAlerts.CreateAlertConfig.Success',
  CreateAlertConfigFailure: 'MetricAlerts.CreateAlertConfig.Failure',
  DuplicateAlertConfigRequest: 'MetricAlerts.DuplicateAlertConfig.Request',
  DuplicateAlertConfigSuccess: 'MetricAlerts.DuplicateAlertConfig.Success',
  DuplicateAlertConfigFailure: 'MetricAlerts.DuplicateAlertConfig.Failure',
  GetAlertsDetailViewRequest: 'MetricAlerts.GetAlertsDetailView.Request',
  GetAlertsDetailViewSuccess: 'MetricAlerts.GetAlertsDetailView.Success',
  GetAlertsDetailViewFailure: 'MetricAlerts.GetAlertsDetailView.Failure',
  GetAlertsListViewRequest: 'MetricAlerts.GetAlertsListView.Request',
  GetAlertsListViewSuccess: 'MetricAlerts.GetAlertsListView.Success',
  GetAlertsListViewFailure: 'MetricAlerts.GetAlertsListView.Failure',
  GetCreateAlertViewRequest: 'MetricAlerts.GetCreateAlertView.Request',
  GetCreateAlertViewSuccess: 'MetricAlerts.GetCreateAlertView.Success',
  GetCreateAlertViewFailure: 'MetricAlerts.GetCreateAlertView.Failure',
  UnarchiveAlertConfigRequest: 'MetricAlerts.UnarchiveAlertConfig.Request',
  UnarchiveAlertConfigSuccess: 'MetricAlerts.UnarchiveAlertConfig.Success',
  UnarchiveAlertConfigFailure: 'MetricAlerts.UnarchiveAlertConfig.Failure',
  UpdateAlertNotificationConfigRequest: 'MetricAlerts.UpdateAlertNotificationConfig.Request',
  UpdateAlertNotificationConfigSuccess: 'MetricAlerts.UpdateAlertNotificationConfig.Success',
  UpdateAlertNotificationConfigFailure: 'MetricAlerts.UpdateAlertNotificationConfig.Failure',
  UpdateAlertsForMetricRequest: 'MetricAlerts.UpdateAlertsForMetric.Request',
  UpdateAlertsForMetricSuccess: 'MetricAlerts.UpdateAlertsForMetric.Success',
  UpdateAlertsForMetricFailure: 'MetricAlerts.UpdateAlertsForMetric.Failure',
  SubscribeAlertNotificationConfigRequest: 'MetricAlerts.SubscribeAlertNotificationConfig.Request',
  SubscribeAlertNotificationConfigSuccess: 'MetricAlerts.SubscribeAlertNotificationConfig.Success',
  SubscribeAlertNotificationConfigFailure: 'MetricAlerts.SubscribeAlertNotificationConfig.Failure',
} as const;

export type MetricAlertsByMetric = { [id: string]: AlertListRow[] };
export type MetricAlertsListMetadata = Omit<GetAlertsListViewResponse, 'rows'>;
